import React, { useEffect, useState, useRef } from "react";
import { Form, Input, Button, ErrorMsg, Toast, Badge } from "../../Components";
import { apis, post } from "../../Utils/axios";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import { useLoginHook } from "../../Hooks/useLoginHook";
import Policy from "../Policy";
import { AUTH_ACTIONS } from "Redux/Reducers/authorization";
import { useDispatch } from "react-redux";
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { getRecaptchaSiteKey, IsDev } from "Utils/utils";
import { getDeviceInfo } from "Utils/getDeviceInfo";

function LoginPage() {
	const { login } = useLoginHook();
	const NAVIGATE = useNavigate();
	const dispatch = useDispatch();
	const [Values, setValues] = useState({
		email: "",
		password: "",
	});
	const [Loader, setLoader] = useState();
	const [Error, setError] = useState();
	const [CaptchaToken, setCaptchaToken] = useState();
	const [TimeZone, setTimeZone] = useState();
	const deviceInfo = useRef(null);

	useEffect(() => {
		//Clear redux store
		dispatch({ type: AUTH_ACTIONS.logout });
		localStorage.removeItem("configuration");
		localStorage.removeItem("authorization");
		//Get the user timezone
		const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
		setTimeZone(tz);
		//Get device info
		deviceInfo.current = getDeviceInfo();

	}, []);

	const onLogin = (e) => {
		if (!IsDev() && !CaptchaToken) {
			return Toast.error("Recaptcha Verification Failed");
		}
		setError();
		setLoader(true);
		post(
			apis.loginUsingEmail,
			{
				email: Values.email,
				password: Values.password,
				timeZone: TimeZone,
				deviceInfo: deviceInfo.current,
			},
			(r, e) => {
				if (r) {
					//Log recaptcha event
					logRecaptchaEvent((res) => {
						//If recaptcha event is logged successfully, login the user
						login(r);
						setLoader();
					});
				} else if (e) {
					setError(e.response?.data.error);
					setLoader();
				}
			}
		);
	};

	const logRecaptchaEvent = async (cb) => {
		post(apis.logRecaptchaEvent, { event: "LOGIN", token: CaptchaToken }, (r, e) => {
			if (r) {
				cb(r);
			} else if (e) {
				console.log(r, e);
			}
		});
	};

	return (
		<>
			<div className="grid h-full p-6 md:grid-cols-2">
				<div className="relative items-end hidden w-full h-full overflow-hidden text-white bg-center bg-no-repeat bg-cover rounded-2xl md:flex" style={{ backgroundImage: `url(https://cdn.travelwings.com/assets/corp/images/airplane.jpg)` }}>
					<div className="absolute left-0 z-10 flex flex-col justify-between h-full p-16" style={{ background: "linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0))" }}>
						<img src="https://cdn.travelwings.com/assets/corp/images/logo_w.png" alt="Logo" className="max-w-[16rem] mb-20" />
						<div className="space-y-12">
							<div className="text-6xl font-bold">Upgrade your Business Travel</div>
							<div className="mt-4">Supercharged Travel & Expense Management System for Corporates to easily manage travel bookings and reimbursements for travellers.</div>
						</div>
					</div>
				</div>
				<div className="flex flex-col h-full">
					<div className="justify-center flex-grow align-center">
						<div className="w-full max-w-xs">
							<div className="flex text-4xl font-bold">
								<FaLock className="mr-2" />
								Log in
							</div>
							<div className="mt-1 text-sm">Enter your credentials to continue</div>
							<div className="flex flex-col mt-10">
								<Form onSubmit={onLogin}>
									<Input value={Values.email} onChange={(email) => setValues((prev) => ({ ...prev, email }))} required label="Email" placeholder="Email" />
									<Input value={Values.password} onChange={(password) => setValues((prev) => ({ ...prev, password }))} required className="mt-2" label="Password" placeholder="Password" type="password" />
									<ErrorMsg e={Error} />
									<div onClick={() => NAVIGATE("/reset")} className="mt-2 text-sm cursor-pointer hover:underline">
										Forgot Password ?
									</div>
									{!CaptchaToken && (
										<Badge variant="warning" className="mt-2">
											Verifying Recaptcha...
										</Badge>
									)}
									<Button onClick={onLogin} loading={(Loader || !CaptchaToken) && !IsDev()} variant="dark" className="w-full mt-4">
										Log in
									</Button>
									<GoogleReCaptchaProvider reCaptchaKey={IsDev() ? "" : getRecaptchaSiteKey()} useEnterprise={true}>
										<GoogleReCaptcha onVerify={setCaptchaToken} />
									</GoogleReCaptchaProvider>
								</Form>

								<div onClick={() => NAVIGATE("/signup")} className="mt-4 text-sm text-center cursor-pointer hover:underline">
									or Create a new account
								</div>
							</div>
						</div>
					</div>
					<Policy className="p-8 mt-6" />
				</div>
			</div>
		</>
	);
}

export default LoginPage;
